import { gatewayPostRequest } from '@/api/clients/gatewayAxios';
import { GatewayImageUploadPayload, GatewayImageUploadResponse } from '@/api/models/GatewayImage';

export const postGatewayImageNew = async (payload: GatewayImageUploadPayload) => {
  const response = await gatewayPostRequest<GatewayImageUploadResponse>('image/new', payload);
  return response.data;
};
